/**
 * Knack localization popover: progressive enhancement for the footer region/currency picker.
 * The picker is a native <details> (works + is accessible with zero JS). This just adds the
 * expected popover niceties: close on outside-click and on Escape. Original Knack code.
 */
(() => {
  const SEL = 'details.knack-loc[open]';

  const closeAll = (except) => {
    document.querySelectorAll(SEL).forEach((d) => {
      if (d !== except) d.open = false;
    });
  };

  document.addEventListener('click', (event) => {
    const openOnes = document.querySelectorAll(SEL);
    if (!openOnes.length) return;
    openOnes.forEach((d) => {
      if (!d.contains(event.target)) d.open = false;
    });
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') closeAll();
  });

  // Only one open at a time.
  document.addEventListener('toggle', (event) => {
    const d = event.target;
    if (d instanceof HTMLDetailsElement && d.matches('.knack-loc') && d.open) closeAll(d);
  }, true);
})();
